import { useEffect, useState } from 'react';
import { Input, } from '../../../common/Forms/Input/Input';
import { ActionButton } from '../../../common/Buttons/Buttons';
import {
  getCorrectDate,
  filterRCVOptions
} from '../../../../assets/helpers/funciones';
import {
  paymentType,
  fleetLoadRCVTypes,
  RCV_Alliance_TYPE,
  rcvOptions
} from '../../../../assets/helpers/options';
import { notify } from '../../../../assets/helpers/toast';
import { OderCardHeader } from './OrderComponents';
import './OrderComponent.scss';
import { statesService } from '../../../../services/statesService.js';
import { RcvHolderFormForAddRcv } from '../../../common/Forms/Form.jsx';
import moment from 'moment';

export const RCVInfoCard = (props) => {
  const { label, membership, card } = props;
  const { useRcvAlliancePrice, onChange } = card;
  const { register, errors, setValue, watch, control } = card.form;

  const [open, setOpen] = useState(true);
  const [rcvBeginDate, setRCVBeginDate] = useState('');

  const [citiesOptions, setCitiesOptions] = useState([]);
  const [statesOptions, setStatesOptions] = useState([]);

  const getCities = (state) => {
    statesService
      .getCities(state ? state : watch('state'), true)
      .then((response) => {
        if (response.status === 200) {
          setCitiesOptions(response?.data?.cities);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch((error) => { });
    return true;
  };

  const handleCity = (e) => {
    getCities(e.target.value);
  };

  const getStates = () => {
    statesService
      .getStates({ isActive: true })
      .then((response) => {
        if (response.status === 200) {
          let states = response?.data?.states;
          setStatesOptions(states);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => { });
  };

  const preloadForm = () => {
    if (membership?.rcvEndDateFromLastMembership) {
      setValue(
        `rcvEndDateFromLastMembership`,
        getCorrectDate(membership?.rcvEndDateFromLastMembership)
      );

      // if rcvEndDateFromLastMembership is greater than today, set rcvEmissionDate as rcvEndDateFromLastMembership + 1 day, else set it as today
      const rcvEndDateFromLastMembership = new Date(
        membership?.rcvEndDateFromLastMembership
      );
      const today = new Date();
      if (rcvEndDateFromLastMembership > today) {
        const nextDay = new Date(
          moment(rcvEndDateFromLastMembership).add(1, 'day')
        );
        setValue('rcvEmissionDate', new Date());

        setValue('rcvBeginDate', nextDay);
        setValue('rcvEndDate', new Date(moment(nextDay).add(1, 'year')));
      } else {
        setValue('rcvEmissionDate', new Date());
        setValue('rcvBeginDate', new Date());
        const nextYear = new Date();
        nextYear.setFullYear(nextYear.getFullYear() + 1);
        setValue('rcvEndDate', nextYear);
      }
    } else {
      setValue('rcvEmissionDate', new Date());
      setValue('rcvBeginDate', new Date());
      const nextYear = new Date();
      nextYear.setFullYear(nextYear.getFullYear() + 1);
      setValue('rcvEndDate', nextYear);
    }

    setValue('rcvType', fleetLoadRCVTypes?.RCV_STANDARD);
  };

  const handleRCVEndDate = (e) => {
    setRCVBeginDate(e);
    setValue(
      'rcvEndDate',
      new Date(e).setFullYear(new Date(e).getFullYear() + 1)
    );
  };

  const openRCVModal = () => {
    setValue('billAmount', watch(`amount`));
    setValue('finalPrice', watch(`amount`));
    setValue('finalPriceInBsS', watch(`amountBsS`)); //Monto en Bs en base a euros

    setValue('paymentMethodsQuantity', 1);
    setValue('paymentType', paymentType?.DE_CONTADO);
    setValue('amount0', watch(`amount`));
    setValue('amountBsS0', watch('finalPriceInBsS')); //Monto en Bs en base a euros
  };

  const handlePaymentDateChange = () => {
    onChange?.getPaymentDateRate();
    onChange?.getEuroRate();
  };

  useEffect(() => {
    Promise.allSettled([preloadForm(), getStates()]).then((r) => {
      setTimeout(() => { }, 1500);
    });
    // preloadKm()
  }, [open]);

  return (
    <>
      <div className="col-12">
        <div className="order-card">
          <OderCardHeader open={open} setOpen={setOpen} label={label} />

          {open && (
            <>
              <br />
              <div style={{ width: '100%' }} className="row">
                <div className="col-12 col-md-4">
                  <div className="row">
                    <p style={{ margin: '0px' }}>(*) Campos obligatorios</p>
                    <h6 style={{ margin: '6px 12px 12px 0px' }}>
                      DATOS DEL CLIENTE
                    </h6>
                    <Input
                      bootstrap={'col-12'}
                      label={'Tipo de RCV'}
                      type={'select'}
                      options={filterRCVOptions(rcvOptions)}
                      name={'rcvType'}
                      register={register}
                      placeholder={''}
                      errors={errors?.rcvType?.message}
                      onChange={() => onChange?.handleUseRcvAlliancePrice(useRcvAlliancePrice)}
                    />
                    {watch('rcvType') && watch('rcvType') !== 'N/A' && (
                      <div className="col-12">
                        <RcvHolderFormForAddRcv
                          register={register}
                          errors={errors}
                          setValue={setValue}
                          watch={watch}
                          citiesOptions={citiesOptions}
                          statesOptions={statesOptions}
                          handleCity={handleCity}
                        />
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-12 col-md-4">
                  <div className="row">
                    <p style={{ margin: '0px' }}>(*) Campos obligatorios</p>
                    <h6 style={{ margin: '6px 12px 12px 0px' }}>
                      DATOS DEL PLAN{' '}
                    </h6>
                    <Input
                      bootstrap={'col-12'}
                      label={'Fecha fin anterior RCV'}
                      type={'date'}
                      name={'rcvEndDateFromLastMembership'}
                      register={register}
                      placeholder={''}
                      control={control}
                      disabled={true}
                      errors={errors?.rcvEndDateFromLastMembership?.message}
                    // minDate={determinValidDate()}
                    // onChange={handleCreationDateChange}
                    />
                    <Input
                      bootstrap={'col-12'}
                      label={'Fecha emisión de RCV'}
                      type={'date'}
                      name={'rcvEmissionDate'}
                      register={register}
                      placeholder={''}
                      control={control}
                      errors={errors?.rcvEmissionDate?.message}
                    />
                    <Input
                      bootstrap={'col-12'}
                      label={'Inicio RCV'}
                      type={'date'}
                      name={'rcvBeginDate'}
                      register={register}
                      placeholder={''}
                      control={control}
                      errors={errors?.rcvBeginDate?.message}
                      onChange={handleRCVEndDate}
                    />
                    <Input
                      bootstrap={'col-12'}
                      label={'Fin RCV'}
                      type={'date'}
                      name={'rcvEndDate'}
                      register={register}
                      placeholder={''}
                      control={control}
                      errors={errors?.rcvEndDate?.message}
                      disabled={true}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-4">
                  <div className="row">
                    <p style={{ margin: '0px' }}>(*) Campos obligatorios</p>
                    <h6 style={{ margin: '6px 12px 12px 0px' }}>
                      DATOS DEL PAGO
                    </h6>

                    <div className="col-12 checbox-input-container">
                      <div style={{ width: "100%" }} className="buttons-container">
                        <div className="topping">
                          <input
                            type="checkbox"
                            id="topping"
                            name="useRcvAlliancePrice"
                            value={RCV_Alliance_TYPE?.FULL_PRICE}
                            checked={
                              useRcvAlliancePrice ===
                              RCV_Alliance_TYPE?.FULL_PRICE
                            }
                            onChange={(e) => onChange?.handleUseRcvAlliancePrice(e.target.value)}
                          />
                          <p style={{ marginBottom: '0px', marginLeft: "5px" }}>
                            {RCV_Alliance_TYPE?.FULL_PRICE}
                          </p>
                        </div>
                        <div className="topping">
                          <input
                            type="checkbox"
                            id="topping"
                            name="useRcvAlliancePrice"
                            value={RCV_Alliance_TYPE?.SC_PRICE}
                            checked={
                              useRcvAlliancePrice ===
                              RCV_Alliance_TYPE?.SC_PRICE
                            }
                            onChange={(e) => onChange?.handleUseRcvAlliancePrice(e.target.value)}
                          />
                          <p style={{ marginBottom: '0px', marginLeft: "5px" }}>
                            {RCV_Alliance_TYPE?.SC_PRICE}
                          </p>
                        </div>
                        <div className="topping">
                          <input
                            type="checkbox"
                            id="topping"
                            name="useRcvAlliancePrice"
                            value={RCV_Alliance_TYPE?.CTG_PRICE}
                            checked={
                              useRcvAlliancePrice ===
                              RCV_Alliance_TYPE?.CTG_PRICE
                            }
                            onChange={(e) => onChange?.handleUseRcvAlliancePrice(e.target.value)}
                          />
                          <p style={{ marginBottom: '0px', marginLeft: "5px" }}>
                            {RCV_Alliance_TYPE?.CTG_PRICE}
                          </p>
                        </div>

                      </div>
                    </div>
                    <Input
                      bootstrap={'col-12'}
                      label={'Fecha de Pago *'}
                      type={'birthday'}
                      name={'paymentDate'}
                      register={register}
                      capitalizeOff={true}
                      placeholder={''}
                      control={control}
                      errors={errors?.paymentDate?.message}
                      onChange={() => handlePaymentDateChange()}
                    />
                    {useRcvAlliancePrice && (
                      <>
                        <Input
                          bootstrap={'col-12 '}
                          label={`Monto USD * Tasa:${card.dollarRate} Bs`}
                          type={'number'}
                          name={'amount'}
                          register={register}
                          placeholder={''}
                          errors={errors?.amount?.message}
                          min={'0'}
                          disabled={true}
                        />
                        {useRcvAlliancePrice ===
                          RCV_Alliance_TYPE?.FULL_PRICE && (
                            <Input
                              bootstrap={'col-12 '}
                              label={`Monto EUR * Tasa:${card.euroRate} Bs`}
                              type={'number'}
                              name={'euroAmount'}
                              register={register}
                              placeholder={''}
                              errors={errors?.EuroAmount?.message}
                              min={'0'}
                              disabled={true}
                            />
                          )}
                        <Input
                          bootstrap={'col-12 '}
                          label={'Monto BsS *'}
                          type={'number'}
                          name={'amountBsS'}
                          register={register}
                          placeholder={''}
                          errors={errors?.amountBsS?.message}
                          disabled={true}
                        />
                        {watch('amount') &&
                          watch('amountBsS') &&
                          !watch('paymentMethodsQuantity') && (
                            <div className="buttons-center-container">
                              <ActionButton
                                label={'Pagar'}
                                action={() => openRCVModal()}
                              />
                            </div>
                          )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};
